import useAgreementStatusTranslations from "../../hooks/useAgreementStatusTranslations";

export default function AgreementStatus({ agreement }) {
	const translations = useAgreementStatusTranslations();

	return translations[agreement.status] || null;
}
